import { useEffect } from "react";

const TawkToChat = () => {
  useEffect(() => {
    // Prevent duplicate widget loading
    if (document.getElementById("tawk-to-script")) return;

    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    const script = document.createElement("script");
    script.id = "tawk-to-script";
    script.async = true;
    script.src = "https://embed.tawk.to/63356a1b54f06e12d8978271/1ge4acv3s";
    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");

    document.body.appendChild(script);

    return () => {
      document.getElementById("tawk-to-script")?.remove();
      document.querySelectorAll('[id^="tawk_"]').forEach((element) => {
        element.remove();
      });
    };
  }, []);

  return null;
};

export default TawkToChat;